<h1 mat-dialog-title>{{ 'labels.heading.Selected Jobs' | translate }}:</h1>

<mat-dialog-content>
  <div class="jobs-container">
    <mifosx-run-selected-jobs-table [selectedJobs]="selectedJobs" (confirmedJobs)="runSelectedJobs()">
    </mifosx-run-selected-jobs-table>
  </div>
</mat-dialog-content>

<mat-list>
  <mat-list-item *ngFor="let message of messages" class="message" ngClass]="{'green' : message.status}">
    {{ message.message }}
  </mat-list-item>
</mat-list>
<mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="runSelectedJobs()">
    <fa-icon icon="play" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Confirm' | translate }}
  </button>
  <button mat-raised-button color="warn" [mat-dialog-close]="{ show: 0 }">
    {{ 'labels.buttons.Cancel' | translate }}
  </button>
</mat-dialog-actions>
